import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { ArrowRight, Shield, Zap } from "lucide-react";

const CTA = () => {
  return (
    <section className="py-20 md:py-28 px-6">
      <div className="container mx-auto">
        <div className="max-w-4xl mx-auto text-center">
          <div className="inline-flex items-center gap-2 bg-cta/10 border border-cta/20 text-cta px-3 py-1.5 rounded-full text-sm font-medium mb-6">
            <Zap className="h-3.5 w-3.5 fill-current" />
            <span>Limited — 127 spots left this month</span>
          </div>
          
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-5 text-balance">
            Stop watching charts.{" "}
            <span className="text-accent">Start catching moves.</span>
          </h2>
          <p className="text-lg text-muted-foreground mb-8 max-w-xl mx-auto">
            Join 4,200+ traders who get volume alerts before the crowd. 
            Start your free trial — setup takes 2 minutes.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-3 justify-center mb-8">
            <Button variant="cta" size="lg" className="text-base font-semibold group" asChild>
              <Link to="/signup">
              Start free trial
              <ArrowRight className="ml-2 h-4 w-4 group-hover:translate-x-0.5 transition-transform" />
              </Link>
            </Button>
            
            <Button variant="outline" size="lg" className="text-base" asChild>
              <Link to="/support">
              Talk to our team
              </Link>
            </Button>
          </div>
          
          <div className="flex flex-wrap items-center justify-center gap-6 text-sm text-muted-foreground">
            <div className="flex items-center gap-1.5">
              <Shield className="h-3.5 w-3.5 text-accent" />
              <span>14-day free trial</span>
            </div>
            <span className="text-border">•</span>
            <span>No credit card required</span>
            <span className="text-border">•</span>
            <span>Cancel in one click</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTA;
